<template>
  <div>
    <div
      class="not-toolbar"
      style="border-bottom:1px solid #EAE9EA;"
    >
      <StoresDropdown
        :filiale="filiale"
        :is-disabled="true"
        :all-included="'All'"
        @updateFiliale="updateFiliale"
      />
      <button
        v-b-modal.create-order-movement-number-internal
        class="primary"
        @click="updateLocations"
      >
        {{ $t('CreateOrderMovementInternal') }}
      </button>
    </div>
    <div style="display:flex;gap:10px;">
      <div style="width: 100%;">
        <div style="width: 100%;">
          <table
            class="team_table"
          >
            <thead>
              <tr>
                <th style="display: flex;gap: 5px">
                  {{ $t('Select') }}
                </th>
                <th>
                  {{ $t('OrderID') }}
                </th>
                <th>
                  {{ $t('ArticleNumber') }}
                </th>
                <th>
                  {{ $t('Actions') }}
                </th>
              </tr>
            </thead>
            <LoadingSpinnerTable
              :is-loading="isRequestLoading('loadLineItemsPaginationInternal')"
              :response-data="getLineItemsPaginationInternal?.items || []"
            >
              <tr
                v-for="(order, index) in getLineItemsPaginationInternal?.items"
                :key="index"
              >
                <td>
                  <input
                    type="checkbox"
                    :value="order.windowItemId"
                    :checked="isOrderItemChecked(order)"
                    @change="event => toggleOrderItem(event, index)"
                  >
                </td>
                <td>
                  {{ order.orderNumber }}
                </td>
                <td>
                  {{ order.articleNumber }}
                </td>
                <td>
                  <b-dropdown
                    size="sm"
                    variant="link"
                    toggle-class="text-decoration-none"
                    no-caret
                  >
                    <template #button-content>
                      <b-icon-three-dots-vertical
                        class="h6"
                        style="color:black"
                      />
                    </template>
                    <b-dropdown-item>
                      <span style="display:flex;gap:5px">
                        <b-icon-pencil />
                        <p>
                          {{ $t('Edit') }}
                        </p>
                      </span>
                    </b-dropdown-item>
                    <b-dropdown-item>
                      <span
                        v-b-modal.delete-line-item-in-pending-modal-internal
                        style="display:flex;gap:5px"
                        @click="orderData(order)"
                      >
                        <b-icon-trash />
                        <p>
                          {{ $t('Delete') }}
                        </p>
                      </span>
                    </b-dropdown-item>
                  </b-dropdown>
                </td>
              </tr>
            </LoadingSpinnerTable>
          </table>
          <div>
            <b-pagination
              v-model="pageNumberOrder"
              :total-rows="getLineItemsPaginationInternal?.totalItems"
              :per-page="pageSize"
              first-number
              last-number
              align="fill"
              size="md"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="updatePageOrders"
            >
              <template #prev-text>
                <span class="previousOrNext"><b-icon-arrow-left />{{ $t('Previous') }}</span>
              </template>
              <template #next-text>
                <span class="previousOrNext">{{ $t('Next') }}<b-icon-arrow-right /></span>
              </template>
            </b-pagination>
          </div>
          <DeleteLineItemInPending
            :clicked-line-item-movement-id="clickedLineItemMovementId"
            :clicked-order-number="clickedOrderNumber"
            @updateLineItemMovement="updateLineItemMovements"
          />
        </div>
      </div>
      <div style="width: 100%;">
        <div style="width: 100%;">
          <table
            class="team_table"
          >
            <thead>
              <tr>
                <th>
                  {{ $t('Select') }}
                </th>
                <th>
                  {{ $t('ArticleNumber') }}
                </th>
                <th>
                  {{ $t('Barcode') }}
                </th>
                <th>
                  {{ $t('Amount') }}
                </th>
                <th>
                  {{ $t('Actions') }}
                </th>
              </tr>
            </thead>
            <LoadingSpinnerTable
              :is-loading="isRequestLoading('loadProductsInStockPaginationInternal')"
              :response-data="getProductsInStockPaginationInternal?.items || []"
            >
              <tr
                v-for="(article, index) in getProductsInStockPaginationInternal?.items"
                :key="index"
              >
                <td>
                  <input
                    type="checkbox"
                    :value="article.productInStockId"
                    :checked="isProductItemChecked(article)"
                    @change="event => toggleProductItem(event, index)"
                  >
                </td>
                <td>
                  {{ article.articleNumber }}
                </td>
                <td>
                  {{ article.barcode || $t('NoBarcode') }}
                </td>
                <td>
                  {{ article.amount }}
                </td>
                <td>
                  <b-dropdown
                    size="sm"
                    variant="link"
                    toggle-class="text-decoration-none"
                    no-caret
                  >
                    <template #button-content>
                      <b-icon-three-dots-vertical
                        class="h6"
                        style="color:black"
                      />
                    </template>
                    <b-dropdown-item>
                      <span
                        v-b-modal.edit-article-in-pending-modal-internal
                        style="display:flex;gap:5px"
                        @click="articleData(article)"
                      >
                        <b-icon-pencil />
                        <p>
                          {{ $t('Edit') }}
                        </p>
                      </span>
                    </b-dropdown-item>
                    <b-dropdown-item>
                      <span
                        v-b-modal.delete-article-in-pending-modal-internal
                        style="display:flex;gap:5px"
                        @click="articleData(article)"
                      >
                        <b-icon-trash />
                        <p>
                          {{ $t('Delete') }}
                        </p>
                      </span>
                    </b-dropdown-item>
                  </b-dropdown>
                </td>
              </tr>
            </LoadingSpinnerTable>
          </table>
          <div>
            <b-pagination
              v-model="pageNumberArticles"
              :total-rows="getProductsInStockPaginationInternal?.totalItems"
              :per-page="pageSize"
              first-number
              last-number
              align="fill"
              size="md"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="updatePageProducts"
            >
              <template #prev-text>
                <span class="previousOrNext"><b-icon-arrow-left />{{ $t('Previous') }}</span>
              </template>
              <template #next-text>
                <span class="previousOrNext">{{ $t('Next') }}<b-icon-arrow-right /></span>
              </template>
            </b-pagination>
          </div>
          <EditArticlePending
            :amount-of-product="amountOfProduct"
            :clicked-article-number="clickedArticleNumber"
            :clicked-product-movement-id="clickedProductMovementId"
            @updateProductsInStockMovement="updateProductsInStockMovements"
          />
          <DeleteArticlePending
            :clicked-product-movement-id="clickedProductMovementId"
            :clicked-article-number="clickedArticleNumber"
            @updateProductsInStockMovement="updateProductsInStockMovements"
          />
        </div>
      </div>
    </div>
    <CreateOrderMovementInternal
      :products-in-stock-list="productsInStockList"
      :order-item-ids="orderItemIds"
      :filiale="filiale"
      @removeListsOrderArticle="removeListsOrderArticles"
      @updateOrderAndArticle="updateOrderAndArticles"
    />
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import StoresDropdown from '../StoresDropdown.vue';
import EditArticlePending from './modals/EditArticlePendingInternal.vue';
import CreateOrderMovementInternal from './modals/CreateOrderMovementInternal.vue';
import DeleteArticlePending from './modals/DeleteArticlePendingInternal.vue';
import DeleteLineItemInPending from './modals/DeleteLineItemPendingInternal.vue';

export default {
  components: {
    StoresDropdown,
    EditArticlePending,
    DeleteArticlePending,
    DeleteLineItemInPending,
    CreateOrderMovementInternal,
  },
  props: [],
  data() {
    return {
      filiale: { storeId: null, storeName: 'All', storeGLN: null },
      pageNumberOrder: 1,
      pageNumberArticles: 1,
      pageSize: 15,
      amountOfProduct: 0,
      clickedProductMovementId: null,
      clickedArticleNumber: null,
      clickedOrderNumber: null,
      clickedLineItemMovementId: null,
      productsInStockList: [],
      orderItemIds: [],
      selectAllProducts: false,
      selectAllOrders: false,
    }
  },
  computed: {
    ...mapGetters([
      'getLineItemsPaginationInternal',
      'getProductsInStockPaginationInternal',
    ]),
  },
  watch: {
  },
  mounted() {

  },
  methods: {
    ...mapActions([
      'loadLineItemsPaginationInternal',
      'loadProductsInStockPaginationInternal',
      'loadCreateOrderMovement',
      'loadLocationsByStoreIdName',
    ]),
    updateLocations() {
      this.loadLocationsByStoreIdName({
        storeId: this.filiale?.storeId,
      })
    },
    resetData() {
      this.productsInStockList = [];
      this.orderItemIds = [];
      this.selectAllProducts = false;
      this.selectAllOrders = false;
      this.loadLineItemsPaginationInternal({
        state: 'Pending',
        storeId: this.filiale?.storeId,
        pageNumber: this.pageNumberOrder,
        pageSize: this.pageSize,
      })
      this.loadProductsInStockPaginationInternal({
        state: 'Pending',
        storeId: this.filiale?.storeId,
        pageNumber: this.pageNumberArticles,
        pageSize: this.pageSize,
      })
    },
    updateOrderAndArticles() {
      this.productsInStockList = [];
      this.orderItemIds = [];
      this.selectAllProducts = false;
      this.selectAllOrders = false;
      this.loadLineItemsPaginationInternal({
        state: 'Pending',
        storeId: this.filiale?.storeId,
        pageNumber: this.pageNumberOrder,
        pageSize: this.pageSize,
      })
      this.loadProductsInStockPaginationInternal({
        state: 'Pending',
        storeId: this.filiale?.storeId,
        pageNumber: this.pageNumberArticles,
        pageSize: this.pageSize,
      })
    },
    removeListsOrderArticles() {
      this.productsInStockList = [];
      this.orderItemIds = [];
      this.selectAllProducts = false;
      this.selectAllOrders = false;
    },
    toggleOrderItem(event, index) {
      const item = this.getLineItemsPaginationInternal?.items[index];
      const itemObject = {
        windowItemId: item.windowItemId,
        orderItemId: item.orderItemId,
        articleNumber: item.articleNumber,
        orderNumber: item.orderNumber,
        lineItemMovementId: item.lineItemMovementId,
      };

      if (event.target.checked) {
        this.orderItemIds.push(itemObject);
      } else {
        const itemIndex = this.orderItemIds.findIndex(
          (i) => { return i.windowItemId === item.windowItemId && i.orderItemId === item.orderItemId && i.articleNumber === item.articleNumber && i.orderNumber === item.orderNumber && i.lineItemMovementId === item.lineItemMovementId },
        );
        if (itemIndex !== -1) {
          this.orderItemIds.splice(itemIndex, 1);
        }
      }
      this.selectAllOrders = this.orderItemIds.length === this.getLineItemsPaginationInternal?.items.length;
    },
    toggleSelectAllOrdersOrder(event) {
      this.selectAllOrders = event.target.checked;

      if (this.selectAllOrders) {
        this.orderItemIds = this.getLineItemsPaginationInternal?.items.map((item) => {
          return {
            windowItemId: item.windowItemId,
            orderItemId: item.orderItemId,
            articleNumber: item.articleNumber,
            orderNumber: item.orderNumber,
            lineItemMovementId: item.lineItemMovementId,
          }
        });
      } else {
        this.orderItemIds = [];
      }
    },
    isOrderItemChecked(item) {
      return this.orderItemIds.some(
        (i) => { return i.windowItemId === item.windowItemId },
      );
    },
    toggleProductItem(event, index) {
      const item = this.getProductsInStockPaginationInternal?.items[index];
      const itemObject = {
        productInStockId: item.productInStockId,
        productInStockMovementId: item.productInStockMovementId,
        amount: item.amount,
        articleNumber: item.articleNumber,
        notes: item.notes || '',
      };

      if (event.target.checked) {
        this.productsInStockList.push(itemObject);
      } else {
        const itemIndex = this.productsInStockList.findIndex(
          (i) => { return i.productInStockId === item.productInStockId && i.amount === item.amount && i.articleNumber === item.articleNumber && i.productInStockMovementId === item.productInStockMovementId },
        );
        if (itemIndex !== -1) {
          this.productsInStockList.splice(itemIndex, 1);
        }
      }
      this.selectAllProducts = this.productsInStockList.length === this.getProductsInStockPaginationInternal?.items.length;
    },
    toggleSelectAllProductsProducts(event) {
      this.selectAllProducts = event.target.checked;

      if (this.selectAllProducts) {
        this.productsInStockList = this.getProductsInStockPaginationInternal?.items.map((item) => {
          return {
            productInStockId: item.productInStockId,
            productInStockMovementId: item.productInStockMovementId,
            amount: item.amount,
            articleNumber: item.articleNumber,
            notes: item.notes || '',
          }
        });
      } else {
        this.productsInStockList = [];
      }
    },
    isProductItemChecked(item) {
      return this.productsInStockList.some(
        (i) => { return i.productInStockId === item.productInStockId },
      );
    },
    updatePageOrders(value) {
      this.loadLineItemsPaginationInternal({
        state: 'Pending',
        storeId: this.filiale?.storeId,
        pageNumber: value,
        pageSize: this.pageSize,
      })
    },
    updatePageProducts(value) {
      this.loadProductsInStockPaginationInternal({
        state: 'Pending',
        storeId: this.filiale?.storeId,
        pageNumber: value,
        pageSize: this.pageSize,
      })
    },
    updateLineItemMovements() {
      this.loadLineItemsPaginationInternal({
        state: 'Pending',
        storeId: this.filiale?.storeId,
        pageNumber: this.pageNumberOrder,
        pageSize: this.pageSize,
      })
    },
    updateProductsInStockMovements() {
      this.loadProductsInStockPaginationInternal({
        state: 'Pending',
        storeId: this.filiale?.storeId,
        pageNumber: this.pageNumberArticles,
        pageSize: this.pageSize,
      })
    },
    articleData(value) {
      this.amountOfProduct = value.amount;
      this.clickedArticleNumber = value.articleNumber
      this.clickedProductMovementId = value.productInStockMovementId;
    },
    orderData(value) {
      this.clickedOrderNumber = value.orderNumber
      this.clickedLineItemMovementId = value.lineItemMovementId;
    },
    updateFiliale(newFiliale) {
      this.filiale = newFiliale;
      this.loadLineItemsPaginationInternal({
        state: 'Pending',
        storeId: this.filiale?.storeId,
        pageNumber: this.pageNumberOrder,
        pageSize: this.pageSize,
      })
      this.loadProductsInStockPaginationInternal({
        state: 'Pending',
        storeId: this.filiale?.storeId,
        pageNumber: this.pageNumberArticles,
        pageSize: this.pageSize,
      })
    },
  },
}
</script>

    <style scoped lang="scss">
    </style>
